export const state = {
  modalViewTransaction: false,
  transactions: [],
  reports: [],
  transaction: {}
};

export default {};
